import React, { Fragment } from 'lib/react';
import {
  EVPaper, EVGrid, EVTypography, EVButton,
} from 'lib/components';
import { useTranslation } from 'lib/translation';
import OrdersList from 'components/orders-list';
import DashboardStyles from 'features/dashboard/DashboardStyles';
import { Link } from 'lib/router';
import { ORDER_HISTORY_ROUTE, ORDER_ROUTE } from 'constants/RouteConstants';
import { getRecentOrdersColumns } from 'features/dashboard/Dashboard.utils';
import useMediaQuery from 'hooks/useMediaQuery';
import { useSelector } from 'lib/redux';
import { isOrderingDisabledSelector } from 'utils/appSelectors.utils';
import DashboardRetry from '../../DashboardRetry.component';

function RecentOrders() {
  const { t } = useTranslation();
  const classes = DashboardStyles();
  const {
    loadError, reportDetails, loading,
  } = useSelector(({ orderHistory }) => ({
    loadError: orderHistory.loadError,
    reportDetails: orderHistory.reportDetails,
    loading: orderHistory.loading,
  }));
  const isOrderingDisabled = useSelector(isOrderingDisabledSelector);
  const isRecentOrdersEmpty = reportDetails === null;
  const isMobile = useMediaQuery(640);

  const MainComponent = isMobile ? Fragment : EVPaper;
  // #genai - Select one recent-orders body without nesting conditional expressions.
  let recentOrdersContent = <OrdersList getFields={getRecentOrdersColumns} />;
  if (loadError) {
    recentOrdersContent = (
      <EVGrid style={{ paddingTop: '16px' }}>
        <DashboardRetry
          retryText={t('dashboard__recent_orders_retry_msg')}
          action="LOAD_RECENT_ORDERS"
          type="recentOrders"
        />
      </EVGrid>
    );
  } else if (isRecentOrdersEmpty && !loading) {
    recentOrdersContent = (
      <EVGrid className={classes.newOrderBtn}>
        <EVTypography>{t('dashboard__no_recent_orders')}</EVTypography>
        <EVButton
          component={Link}
          to={ORDER_ROUTE}
          variant="contained"
          color="primary"
          className={classes.startNewOrderBtn}
        >
          {t('dashboard__start_new_order')}
        </EVButton>
      </EVGrid>
    );
  }

  return (
    <MainComponent className={classes.recentOrders}>
      <EVGrid className={classes.recentOrdersHeader}>
        <EVTypography className={classes.recentOrdersTitle}>{t('dashboard__recent_orders')}</EVTypography>
        {(!isRecentOrdersEmpty || loadError) && (
        <EVGrid className={classes.recentOrdersButtons}>
          <EVButton
            component={Link}
            to={ORDER_HISTORY_ROUTE}
            variant="outlined"
            color="primary"
          >
            {t('dashboard__view_all_orders')}
          </EVButton>
          {!isOrderingDisabled && (
          <EVButton
            component={Link}
            to={ORDER_ROUTE}
            variant="contained"
            color="primary"
          >
            {t('dashboard__start_new_order')}
          </EVButton>
          )}
        </EVGrid>
        )}
      </EVGrid>
      {recentOrdersContent}
    </MainComponent>
  );
}

export default RecentOrders;
